// src/utils/translations.js
import translationFile from '../locales/en/translation.json';

export const getErrorMessage = (errorCode) => {
    return translationFile.errorMessages[errorCode];
};